'use client';
import { normalize, schema } from 'normalizr';
import { dryFetch } from '../../utils/dryFetch';
import logger from '../../logger';

const notesSchema = new schema.Entity('notes', {}, { idAttribute: 'note_id' });
const notesListSchema = new schema.Array(notesSchema);

export const trashNoteInCloud = async ({ noteId }) => {
  const json = await dryFetch({
    name: 'trashNote',
    path: `/note/${noteId}/trash`,
    options: { method: 'PUT' },
  });
  return json;
};

export const fetchTrashedNotesFromCloud = async () => {
  try {
    const json = await dryFetch({ name: 'fetchTrashedNotes', path: '/trash' });
    const list = json?.notes ?? [];
    const normalized = normalize(list, notesListSchema);
    return normalized.entities.notes ?? {};
  } catch (error) {
    logger.error(error, 'fetchTrashedNotesFromCloud failed');
    throw error;
  }
};
